// src/pages/Concierge/steps/Step1.jsx
import React from "react";

export default function Step1({ data, update }) {
  const name = (data.name || "").trim();
  const phoneRaw = data.phone || "";
  const phoneDigits = phoneRaw.replace(/\D/g, "");

  const isNameValid = name === "" ? true : name.length >= 2;
  const isPhoneValid = phoneDigits === "" ? true : /^010\d{8}$/.test(phoneDigits);

  const baseInputStyle = {
    color: "var(--ink-default,#1F2937)",
    borderBottom: "1px solid var(--coolgrey-200,#E3E7EF)",
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex justify-end">
        <a
          href="/concierge/manage/login"
          className="inline-flex items-center rounded-full bg-[#7864F9] px-4 py-2 text-xs font-semibold text-white shadow-[0_10px_24px_rgba(120,100,249,0.28)]"
        >
          컨시어지 관리
        </a>
      </div>

      <Field label="이름">
        <input
          className="w-full bg-transparent py-2 outline-none placeholder:opacity-60"
          style={baseInputStyle}
          placeholder="이름을 입력해 주세요"
          value={data.name ?? ""}
          onChange={(e) => update({ name: e.target.value })}
        />
        {!isNameValid && (
          <p className="mt-1 text-xs text-red-500">이름은 2글자 이상 입력해 주세요.</p>
        )}
      </Field>

      <Field label="휴대폰 번호">
        <input
          className="w-full bg-transparent py-2 outline-none placeholder:opacity-60"
          style={baseInputStyle}
          inputMode="tel"
          placeholder="- 없이 입력해 주세요"
          value={phoneRaw}
          maxLength={11}
          onChange={(e) => {
            const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 11);
            update({ phone: onlyDigits });
          }}
        />
        {!isPhoneValid && (
          <p className="mt-1 text-xs text-red-500">
            올바른 휴대폰 번호를 입력해 주세요. 예: 01012345678
          </p>
        )}
      </Field>

      <Field label="PIN 번호(6자리)">
        <input
          className="w-full bg-transparent py-2 outline-none placeholder:opacity-60"
          style={baseInputStyle}
          type="password"
          maxLength={6}
          placeholder="******"
          value={data.pin ?? ""}
          onChange={(e) => update({ pin: e.target.value.replace(/\D/g, "") })}
        />
        <p className="mt-2 text-xs" style={{ color: "var(--coolgrey-600,#47526B)" }}>
          PIN 번호는 이후 컨시어지 관리 로그인에 사용하는 6자리 숫자입니다. 안전하게
          보관해 주세요.
        </p>
      </Field>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <p className="mb-2 text-sm font-semibold" style={{ color: "var(--ink-strong,#101828)" }}>
        {label}
      </p>
      {children}
    </div>
  );
}
